const svgSpriteUrl = 'assets/images/svg/sprite.svg';

window.onload = function (event) {
    const ajax = new XMLHttpRequest();
    ajax.open("GET", svgSpriteUrl, true);
    ajax.send();
    ajax.onload = function() {
        const blIcons = document.createElement("div");
        blIcons.style.display = 'none';
        blIcons.innerHTML = ajax.responseText;
        document.documentElement.insertBefore(blIcons, document.documentElement.firstChild);
    }
}